import { AbstractAgent } from "@copilotkit/react-core/v2"
import { StoreCore, addWatch, createStore } from "@priolo/jon"
import farmSo from "stores/farm"
import { Farm } from "types/Farm"



const setup = {

	state: () => ({
		// actions: [] as ActionDescriptor[],
		// descriptions: [] as PageDescriptor[],
		agent: <AbstractAgent>null
	}),

	getters: {
	},

	actions: {
		// setDescription: (description: PageDescriptor, store?: CopilotKitStore) => {
		// 	const index = store.state.descriptions.findIndex(d => d.id == description.id)
		// 	if (index >= 0) {
		// 		store.state.descriptions[index] = description
		// 		store.setDescriptions([...store.state.descriptions])
		// 	} else {
		// 		store.setDescriptions([...store.state.descriptions, description])
		// 	}
		// },
		// removeDescription: (id: string, store?: CopilotKitStore) => {
		// 	const index = store.state.descriptions.findIndex(d => d.id == id)
		// 	if (index >= 0) {
		// 		store.state.descriptions.splice(index, 1)
		// 		store.setDescriptions([...store.state.descriptions])
		// 	}
		// },
		// removeAllDescriptions: (_: void, store?: CopilotKitStore) => {
		// 	store.setDescriptions([])
		// },

		// /**
		//  * inerisce o modifica un ACTION
		//  */
		// setAction: (action: ActionDescriptor, store?: CopilotKitStore) => {
		// 	const index = store.state.actions.findIndex(a => a.name == action.name)
		// 	// decorate
		// 	// const original = action.handler
		// 	// action.handler = async (params: any): Promise<void> => {
		// 	// 	store.state.recall = params.recall ?? false
		// 	// 	return await original(params)
		// 	// }

		// 	if (index >= 0) {
		// 		store.state.actions[index] = action
		// 		store.setActions([...store.state.actions])
		// 	} else {
		// 		store.setActions([...store.state.actions, action])
		// 	}
		// },
		// removeAction: (name: string, store?: CopilotKitStore) => {
		// 	const index = store.state.actions.findIndex(a => a.name == name)
		// 	if (index == -1) return
		// 	store.state.actions.splice(index, 1)
		// 	store.setActions([...store.state.actions])
		// },
		// removeAllActions: (_: void, store?: CopilotKitStore) => {
		// 	store.setActions([])
		// },

	},

	mutators: {
		// setActions: (actions: ActionDescriptor[]) => ({ actions }),
		// setDescriptions: (descriptions: PageDescriptor[]) => ({ descriptions }),
	},
}

export type CopilotKitState = ReturnType<typeof setup.state>
export type CopilotKitGetters = typeof setup.getters
export type CopilotKitActions = typeof setup.actions
export type CopilotKitMutators = typeof setup.mutators
export interface CopilotKitStore extends StoreCore<CopilotKitState>, CopilotKitGetters, CopilotKitActions, CopilotKitMutators {
	state: CopilotKitState
}
const copilotKitSo = createStore(setup) as CopilotKitStore
export default copilotKitSo



export enum CK_DESC_ID {
	FARMS_LIST = "farms:list",
	CROPS_LIST = "crops:list",
	CROPS_FOLDERS = "crops:folders",
}

export interface PageDescriptor {
	id?: string
	description: string
	value: any
}

// export interface ActionDescriptor {
// 	/** nome univoco */
// 	name: string
// 	/** descrizione che legge l'AGENT */
// 	description: string
// 	/** parametri della funzione */
// 	parameters: { name: string, type: string, description: string, required?: boolean }[]
// 	/** funzione richiamata */
// 	handler: (params: any) => Promise<void>
// 	/** indica se questa ACTION è al momento utilizzata */
// 	available?: "enabled" | "disabled" | "remote"
// }


// addWatch({
// 	store: farmSo,
// 	actionName: "setAll",
// 	callback: (value) => {
// 		const farms = value?.payload as Farm[]
// 		// se non ci sono farms
// 		if (!farms?.length) {
// 			copilotKitSo.setDescription({
// 				id: CK_DESC_ID.FARMS_LIST,
// 				description: "Non ci sono FARM al moemnto",
// 				value: []
// 			})
// 			return
// 		}
// 		// altrimenti aggiorna la descrizione della lista delle farms
// 		copilotKitSo.setDescription({
// 			id: CK_DESC_ID.FARMS_LIST,
// 			description: "La lista delle FARMS è:",
// 			value: farms.map(farm => ({
// 				id: farm.id,
// 				name: farm.name,
// 				country: farm.country
// 			}))
// 		})
// 	}
// })
